import { Image, Link, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowPrijemEvdListaDefinisanihTacakaHeader: React.FC<{
  primalac: string;
  potpisano: string;
  datum: string;
  posiljalac: string;
  potpisPosiljalac: string;
  dokument: string;
  primjedba: string;
  korektivnaMjera: string;
  temperatura: string;
}> = ({
  datum,
  posiljalac,
  potpisPosiljalac,
  dokument,
  primjedba,
  korektivnaMjera,
  temperatura,
  potpisano,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{posiljalac}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{potpisPosiljalac}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{dokument}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{primjedba}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{korektivnaMjera}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{temperatura}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{potpisano}</Text>
    </View>
  </View>
);

export const TableRowPrijemEvdListaDefinisanihTacaka: React.FC<{
  primalac: string;
  potpisano: string;
  datum: string;
  posiljalac: string;
  potpisPosiljalac: string;
  dokument?: string;
  primjedba: string;
  korektivnaMjera: string;
  temperatura: string;
  slikaRes: string;
}> = ({
  datum,
  posiljalac,
  potpisPosiljalac,
  dokument,
  primjedba,
  korektivnaMjera,
  temperatura,
  potpisano,
  slikaRes,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{posiljalac}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpisPosiljalac && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={potpisPosiljalac}
        />
      )}
    </View>
    <View style={styles.tableCol}>
      {dokument && (
        <Link src={dokument} style={{ ...styles.tableCell, ...styles.link }}>
          {slikaRes}
        </Link>
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{primjedba}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{korektivnaMjera}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{temperatura}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpisano && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={potpisano}
        />
      )}
    </View>
  </View>
);
